import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWetter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#wetter_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M18.372 22.472c-1.263 0-1.828-1.098-1.828-2.185 0-.735.785-1.518 1.457-1.965a.77.77 0 0 0 .34-.642V3.822c0-.666.245-.955.37-.955.126 0 .372.289.372.955v1.53a.377.377 0 0 0-.371.381c0 .211.166.383.371.383v1.528a.377.377 0 0 0-.371.382c0 .211.166.383.371.383v1.528a.377.377 0 0 0-.371.383c0 .21.166.382.371.382v1.528a.377.377 0 0 0-.371.383c0 .21.166.382.371.382v1.529a.377.377 0 0 0-.371.382c0 .21.166.382.371.382v2.392c0 .259.128.5.34.642.543.361 1.092 1.109 1.092 1.965 0 1.204-.962 2.185-2.143 2.185m-1.517-18.65c0-3.262 3.714-3.262 3.714 0v13.473c.72.615 1.431 1.672 1.431 2.992C22 22.334 20.373 24 18.372 24c-1.92 0-3.314-1.562-3.314-3.714 0-1.408 1.128-2.488 1.797-3.005zm-4.456 12.995c.41 0 .742.342.742.764v3.057a.754.754 0 0 1-.742.765.754.754 0 0 1-.743-.765v-3.057c0-.422.332-.764.742-.764m-5.068-1.91a.646.646 0 0 1 .932 0 .69.69 0 0 1 0 .96l-2.02 2.077a.647.647 0 0 1-.932 0 .693.693 0 0 1 0-.959zm5.08-9.7c.844 0 1.683.209 2.428.603a.775.775 0 0 1 .32 1.03.73.73 0 0 1-1 .33 3.7 3.7 0 0 0-1.748-.434c-2.113 0-3.833 1.769-3.833 3.944s1.72 3.943 3.833 3.943a3.75 3.75 0 0 0 1.909-.522.733.733 0 0 1 1.014.28.777.777 0 0 1-.273 1.044 5.2 5.2 0 0 1-2.65.727c-2.933 0-5.318-2.455-5.318-5.472s2.385-5.473 5.318-5.473m-6.697 4.73c.41 0 .742.343.742.765a.754.754 0 0 1-.742.764H2.743A.754.754 0 0 1 2 10.702c0-.422.333-.765.743-.765zM5.31 3.36a.646.646 0 0 1 .931 0l2.02 2.078a.69.69 0 0 1 0 .96.65.65 0 0 1-.93 0L5.31 4.318a.693.693 0 0 1 0-.96M12.399 0c.41 0 .742.343.742.765v3.058a.754.754 0 0 1-.742.764.754.754 0 0 1-.743-.764V.765c0-.422.332-.764.742-.764"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="wetter_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWetter;
